import { format } from 'date-fns';

export const formatDate = (milliseconds: string | number) => {
    return format(new Date(milliseconds), 'dd/MM/yyyy')
}
